import salesChannel from "./salesChannel";
import integration from "./integration";
import webapp from "./webapp";
import clientCredentials from "./clientCredentials";
import getRefreshToken from "./refreshToken";
const authorizeWebapp = webapp,
  getCustomerToken = salesChannel,
  getIntegrationToken = integration,
  getSalesChannelToken = salesChannel,
  getWebappToken = webapp;
export { authorizeWebapp, clientCredentials, getCustomerToken, getIntegrationToken, getRefreshToken, getSalesChannelToken, getWebappToken };
const CLayerAuth = {
  authorizeWebapp,
  clientCredentials,
  getCustomerToken,
  getIntegrationToken,
  getRefreshToken,
  getSalesChannelToken,
  getWebappToken
};
export default CLayerAuth;